import { get } from "lib/fetch";

export const USER_AUTH = "user/USER_AUTH";
export const USER_VALIDATE = "user/USER_VALIDATE";

export const userLogIn = (data: any) => ({
  type: USER_AUTH,
  payload: data,
});

export const userLoginValid = () => ({
  type: USER_VALIDATE,
  payload: get("/v1/userinfo"),
});
